module.exports = "../study/imgs/maps/Nagano/S8/Helth/Mosquito/Nagano_Mosquito_HadGEM2_RCP26_Mid.png";